// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3NnIP","label":"SetPasswdForm_label__2EvSu"};